import React from "react";
import { STATUS_BAR, STATUS_STYLE, hm, dayKey } from "./calendarUtils";

/* Eén afspraak-chip; versleepbaar (HTML5 DnD) */
export const ApptChip = ({ a, onOpen, dense, t }) => (
  <div draggable={a.status !== "completed" && a.status !== "cancelled"}
       onDragStart={(e) => { e.dataTransfer.setData("text/appt", a.id); e.dataTransfer.effectAllowed = "move"; }}
       onClick={(e) => { e.stopPropagation(); onOpen(a); }}
       className={`group relative rounded-md border pl-2 pr-1.5 py-1 text-[11px] cursor-pointer hover:shadow-sm transition-shadow ${STATUS_STYLE[a.status] || ""} ${dense ? "truncate" : ""}`}
       title={`${hm(a.scheduled_at)} · ${a.customer_name || t("walkIn")} · ${a.service_type}`} data-testid={`appt-chip-${a.id}`}>
    <span className={`absolute left-0 top-1 bottom-1 w-[3px] rounded-full ${STATUS_BAR[a.status]}`} />
    <span className="font-mono font-semibold">{hm(a.scheduled_at)}</span>{" "}
    <span className="font-medium">{a.customer_name || a.service_type}</span>
    {!dense && <div className="truncate opacity-80">{a.car_plate ? <span className="font-mono">{a.car_plate} · </span> : null}{a.service_type}{a.mechanic_name ? ` · ${a.mechanic_name}` : ""}</div>}
  </div>
);

export const MonthView = ({ cells, month, apptByDay, selectedDay, onSelect, onNew, onOpen, onDrop, t, meta }) => {
  const todayKey = dayKey(new Date().toISOString());
  const weekdays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  return (
    <div data-testid="cal-month-view">
      <div className="grid grid-cols-7 gap-1 mb-1">{weekdays.map((w) => <div key={w} className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground text-center py-1">{t("dow_" + w)}</div>)}</div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d) => {
          const k = dayKey(d.toISOString()); const items = apptByDay[k] || []; const isSel = k === dayKey(selectedDay.toISOString());
          const out = d.getMonth() !== month;
          return (
            <div key={k} onClick={() => onSelect(d)} onDoubleClick={() => onNew(d)}
                 onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add("ring-2", "ring-primary"); }}
                 onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-primary")}
                 onDrop={(e) => { e.preventDefault(); e.currentTarget.classList.remove("ring-2", "ring-primary"); const id = e.dataTransfer.getData("text/appt"); if (id) onDrop(id, d, null); }}
                 className={`min-h-[96px] md:min-h-[112px] p-1.5 rounded-lg border cursor-pointer transition-colors ${isSel ? "border-primary bg-primary/5" : "border-border hover:border-primary/40"} ${out ? "opacity-40" : ""}`} data-testid={`cal-day-${k}`}>
              <div className="flex items-center justify-between mb-1">
                <span className={`text-xs font-mono h-5 w-5 grid place-items-center rounded-full ${k === todayKey ? "bg-primary text-primary-foreground font-bold" : "text-muted-foreground"}`}>{d.getDate()}</span>
                {items.length > 0 && <span className="text-[9px] font-mono text-muted-foreground">{items.length}</span>}
              </div>
              <div className="space-y-0.5">
                {items.slice(0, 3).map((a) => <ApptChip key={a.id} a={a} onOpen={onOpen} dense t={t} />)}
                {items.length > 3 && <div className="text-[10px] text-muted-foreground text-center">+{items.length - 3}</div>}
              </div>
            </div>);
        })}
      </div>
    </div>
  );
};
